import React from "react";
import VideoPlayer from "./VideoPlayer";

export default function WelcomeVideoModal({ src, poster, onClose }) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.75)",
        zIndex: 20000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "24px",
          borderRadius: "18px",
          maxWidth: "800px",
          width: "94vw",
          boxShadow: "0 6px 42px #0007",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <VideoPlayer
          src={src}
          poster={poster}
          muted
          autoPlay
          controls
          style={{ width: "100%" }}
          onEnded={onClose}
        />
      </div>
    </div>
  );
}
